export const TOGGLE_PROFILE_DROPDOWN = "TOGGLE_PROFILE_DROPDOWN";
export const TOGGLE_NOTIFICATION_DROPDOWN = "TOGGLE_NOTIFICATION_DROPDOWN";
export const TOGGLE_LIVE_STATUS_DROPDOWN = "TOGGLE_LIVE_STATUS_DROPDOWN";
export const CLOSE_ALL_DROPDOWNS = 'CLOSE_ALL_DROPDOWNS';

export const TOGGLE_VIEW = "TOGGLE_VIEW";
export const NEXT_PAGE = "NEXT_PAGE";
export const PREV_PAGE = "PREV_PAGE";
export const GO_TO_PAGE = "GO_TO_PAGE";
export const SET_ACTIVE_ITEM = "SET_ACTIVE_ITEM";

export const setActiveItem = (text) => ({
  type: SET_ACTIVE_ITEM,
  payload: text,
});